import { alpha, Box, Chip, MenuItem, Select, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";

export default function MainMultipleSelect({
    label,
    value,
    onChange,
    options,
    size = "small",
    sx,
}) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    return (
        <Box>
            {label && <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                {label}
            </Typography>}
            <Select
                size={size}
                value={value}
                renderValue={(selected) => {
                    return <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.3 }}>
                        {selected.map((item) => (
                            <Chip
                                key={item}
                                label={item}
                                onMouseDown={(event) => {
                                    event.stopPropagation();
                                }}
                                onDelete={() => {
                                    onChange(selected.filter((i) => i !== item));
                                }}
                            />
                        ))}
                    </Box>
                }}
                onChange={(e) => {
                    onChange(e.target.value);
                }}
                multiple
                fullWidth
                sx={{
                    ...sx,
                    '& .MuiSelect-outlined': {
                        backgroundColor: alpha(Constants.Colors[currentMode].background, 1),
                        fontSize: "14px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[currentMode].border,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[currentMode].accent,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[currentMode].accent,
                    },
                }}
            >
                {options?.map((option) => (
                    <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{
                            "&:hover": {
                                backgroundColor: alpha(Constants.Colors[currentMode].accent, 0.8),
                            },
                            "&.Mui-selected": {
                                backgroundColor: alpha(Constants.Colors[currentMode].accent, 1),
                                "&:hover": {
                                    backgroundColor: alpha(Constants.Colors[currentMode].accent, 0.8),
                                }
                            }
                        }}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
}